module.exports = __webpack_public_path__ + "img/how_it_works_icon_2.ce571efd.png";